// src/views/Users/Customers/Customers.jsx
import { useState, useEffect, useRef } from "react";
import ActionsDataTable from "../../../shared/DataTable/ActionsDataTable";
import { globalConstants, modeConstants, typeConstants } from "../../../constants";
import { useNavigate } from "react-router-dom";
import AddRecruiterModal from "../../../shared/Modals/RecruiterModal";
import ViewAssignedProjectsModal from "../../../shared/Modals/AssignedProjectsModal";
import { recruiterActions, screenActions } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { getUserData, SCREENS_IDS } from "../../../system";

export default function Recruiter() {
  const initialGridState = {
    length: 10,
    pageNumber: 1,
    orderBy: "id desc",
    filterQuery: null,
    search: null,
    filterExpression: globalConstants.FILTER_EXPRESSION,
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const sortingInProgressRef = useRef(false);

  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  const [rowData, setRowData] = useState({ items: [], total: 0 });

  // modal state
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  const [showRecruiterModal, setShowRecruiterModal] = useState(false);
  const [showAssignedProjectsModal, setShowAssignedProjectsModal] =
    useState(false);
  const user = getUserData();
  const allData = useSelector((s) => s.recruiterReducer.data);

  // table columns matching the screenshot order
  const actions =
  {
    name: "Actions",
    sortable: false,
    width: "170px",
    cell: (row) => (
      <div
        className="d-flex align-items-center gap-2"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          title="Edit"
          aria-label="Edit"
          onClick={() => {
            getRowData(row, modeConstants.UPDATE_MODE);
            setShowRecruiterModal(true);
          }}
        >
          <i className="bi bi-pencil" />
        </button>

        <button
          type="button"
          className="btn btn-sm btn-outline-success"
          title="View"
          aria-label="View"
          onClick={() => {
            getRowData(row, modeConstants.VIEW_MODE);
            setShowRecruiterModal(true);
          }}
        >
          <i className="bi bi-eye" />
        </button>
        <div className="dropdown">
          <button
            className="btn btn-sm btn-outline-secondary"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            title="More"
          >
            <i className="bi bi-three-dots-vertical" />
          </button>
          <ul
            className="dropdown-menu dropdown-menu-end"
            onClick={(e) => e.stopPropagation()}
          >
            <li>
              <button
                className="dropdown-item"
                onClick={() => {
                  getRowData(row, modeConstants.ADD_MODE);
                  dispatch(
                    recruiterActions.getAllAssignedProjects(
                      initialGridState,
                      row.id
                    )
                  );
                  setShowAssignedProjectsModal(true);
                }}
              >
                <i className="bi bi-plus-circle me-2" /> Assigned Projects
              </button>
            </li>
          </ul>
        </div>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  };

  const getRowData = (row, nextMode) => {
    dispatch(recruiterActions.getRecruiterById(row.id));
    setMode(nextMode);
  };

  const toggleStatus = (id) => {
    dispatch(recruiterActions.deleteRecruiterById(id));
  };

  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection
      ? sortDirection.toUpperCase() // "ASC" | "DESC"
      : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
    dispatch(recruiterActions.getAllRecruiters(gridState));
  };
  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  useEffect(() => {
    getAll();
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  useEffect(() => {
    if (!showAssignedProjectsModal) {
      dispatch(screenActions.getColumnsByScreenId(SCREENS_IDS.RECRUITERS));
      dispatch(screenActions.getUserPreferencesByScreenId(SCREENS_IDS.RECRUITERS));
    }
  }, [showAssignedProjectsModal]);

  return (
    <>
      {/* Recruiter modal (create/edit/view) */}
      <AddRecruiterModal
        show={showRecruiterModal}
        onHide={() => setShowRecruiterModal(false)}
        mode={mode}
      />

      {showAssignedProjectsModal && <ViewAssignedProjectsModal
        show={showAssignedProjectsModal}
        onHide={() => setShowAssignedProjectsModal(false)}
        mode={mode}
      />}


      <ActionsDataTable
        actions={actions}
        data={rowData.items}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        selectableRows
        selectableRowsHighlight
        selectableRowsVisibleOnly
        paginationServer
        onSort={onSort}
        gridState={gridState}
        paginationTotalRows={rowData.total}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationDefaultPage={defaultPage}
        paginationResetDefaultPage
        setShowModal={setShowRecruiterModal}
        setMode={setMode}
        setGridState={setGridState}
        sortServer={true}
        allowCreation={user.userTypeId == typeConstants.PLATFORM_ADMIN}
        screenId={SCREENS_IDS.RECRUITERS}
        toggleStatus={toggleStatus}
      />
    </>
  );
}
